import {TagSelection} from '../tags/tag-selection';
import {GlobalSearchVisibilityMode} from '../shared/search/GlobalSearchVisibilityMode';
export interface SearchFilters {
  resultType: 'all' | 'items' | 'containers';
  visibility: GlobalSearchVisibilityMode;
  containerId: string;
  tags?: TagSelection;
}
export const defaultSearchFilters = (): SearchFilters => ({resultType: 'all', visibility: 'withoutZeroCount', containerId: ''});
